import React from 'react';

const LAST_VISIT_KEY = 'app:TKWws:wwsBuilderLastVisit';

// set in local storage the last visit timestamp
// used to capture when the user last visited the website admin, or preview editor
// used by other repos/pages/products like The Plan
export const useSetLastVisitTimestamp = () => {
  React.useEffect(() => {
    localStorage.setItem(LAST_VISIT_KEY, new Date().toISOString());
  }, []);
};
